import * as React from "react";
import { IdStyles } from "../../../../../less/IdStyles";
import { IdLoca } from "../../../../../utils/i18n/IdLoca";
import { ButtonSecondaryAccentLarge } from "../../../../generic/common/ButtonSecondaryAccentLarge";
import { Icon } from "../../../../generic/icon/Icon";
import { IdIcon } from "../../../../generic/icon/IdIcon";
import { TextLoca } from "../../../../generic/text/TextLoca";
export var ButtonQuestShowMe = function (_a) {
    var onClick = _a.onClick, taskCompleted = _a.taskCompleted, questTask = _a.questTask;
    if (taskCompleted || questTask.noShowMe) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(ButtonSecondaryAccentLarge, { onClick: onClick },
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement("div", { className: "" + IdStyles.TextBoldPrimary },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.showMe })),
            React.createElement("div", { className: "flex flex--guts" },
                React.createElement(Icon, { icon: IdIcon.GreenArrowIcn, styleId: IdStyles.IconMedium })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/ButtonQuestShowMe.tsx
// module id = 141
// module chunks = 3